export default __webpack_public_path__ + "static/media/broccoloTtsIt_It60.c1767e7f.mp3";